<div class="input-group mr-2">
  <input class="form-control" (blur)="inputBlur($event)" [ngModel]="date | date:inputDatetimeFormat"
    (change)="onInputChange($event)" [disabled]="disabled" />

  <div class="input-group-append">
    <button class="btn btn-outline-secondary" [ngbPopover]="calendarContent" [disabled]="disabled" type="button">
      <i class="fas fa-calendar"></i>
    </button>
  </div>
</div>

<ng-template #calendarContent>
  <div>
    <div *ngIf="!showTimePickerToggle">
      <div class="mt-auto mb-1">
        <ngb-datepicker id="dp" #dp name="datepicker" [ngModel]="datetime" (ngModelChange)="onDateChange($event)">
        </ngb-datepicker>
      </div>
      <button class="btn btn-sm btn-default" type="button" (click)="setTodaysDate($event,dp)">
        Dziś
      </button>
      <button class="btn btn-sm btn-default" [disabled]="!datetime?.day" type="button"
        (click)="toggleDateTimeState($event)">
        Czas &nbsp; <i class="fas fa-clock    "></i>
      </button>
      <button class="btn btn-sm btn-default float-right" type="button" (click)="closePopover($event)">
        Zamknij
      </button>
    </div>
    <div *ngIf="showTimePickerToggle">
      <div class="mt-auto mlr-auto mb-1">
        <ngb-timepicker #tp name="timepicker" [ngModel]="datetime" (ngModelChange)="onTimeChange($event)"
          [seconds]="seconds" [hourStep]="hourStep" [minuteStep]="minuteStep" [secondStep]="secondStep">
        </ngb-timepicker>
      </div>
      <button class="btn btn-sm btn-default" type="button" (click)="setCurrentTime($event,tp)">
        Teraz
      </button>
      <button class="btn btn-sm btn-default" [ngbPopover]="calendarContent" type="button"
        (click)="toggleDateTimeState($event)">
        Data &nbsp;<i class="fas fa-calendar"></i>
      </button>
      <button class="btn btn-sm btn-default float-right" type="button" (click)="closePopover($event)">
        Zamknij
      </button>
    </div>
  </div>
</ng-template>
